import React from 'react';
import NumberMultipleCheckbox from 'components/ScalarSpreadsheet/components/number-multiple-checkbox/NumberMultipleCheckbox';
import { NumberMultipleCheckboxProps } from 'components/ScalarSpreadsheet/components/number-multiple-checkbox/NumberMultipleCheckbox.props';
import {
  PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
  SHEET_ALIASES_CONSTANTS,
  SHEET_TITLES_CONSTANTS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { CalibrationPerformanceRow } from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/config/customParser/types';
import { generateColumnKey, getArrayValue, getStringValue } from 'utilities';
import { CalibrationComparison, ComparisonCompaniesParams, RowConfigCalibrationParams } from './types';
import { oneDecimalPercentFormatValidateFloatTrue } from '../../../../../../../common/formats/formats';
import { PERCENTILE_RANKING_TITLE } from '../../../../guidelinePublicCompanies/constants';

const comparisonCompanies = (params: ComparisonCompaniesParams): CalibrationPerformanceRow[] => {
  const { gpcComparison, isDisabled } = params;

  return getArrayValue(
    gpcComparison
      ?.filter(comparison => comparison.name !== '0')
      .map(
        comparison =>
          ({
            alias: generateColumnKey({
              name: getStringValue(comparison.cap_iq_id ?? comparison?.name ?? comparison?.company_name ?? ''),
              prefix: PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
            }),
            gridType: 'string',
            ignoreRowCopy: true,
            readOnly: true,
            value: getStringValue(comparison?.name || comparison?.company_name),
            isClassNameRequired: true,
            isComparisonRow: true,
            enabled: comparison.enabled,
            ...(!isDisabled && {
              dataEditor: (props: NumberMultipleCheckboxProps) => <NumberMultipleCheckbox {...props} />,
              valueViewer: (props: NumberMultipleCheckboxProps) => <NumberMultipleCheckbox {...props} />,
              isEditableTitleCell: true,
              useScalarSpreadsheetCell: true,
            }),
            rowHeaderName: getStringValue(comparison.name),
            rowHeaderId: getStringValue(comparison.cap_iq_id),
          }) as CalibrationPerformanceRow
      )
  );
};

const rowConfigCalibrationPerformance = (params: RowConfigCalibrationParams): CalibrationPerformanceRow[] => {
  const { valuationsApproachGpc, company, gpcComparisonByDate, isDisabled } = params;
  let gpcComparison = getArrayValue(valuationsApproachGpc?.gpc_comparison);

  if (gpcComparisonByDate !== undefined) {
    gpcComparison = gpcComparisonByDate;
  }

  return [
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADER_TITLE,
      className: 'division-bottom-only',
      gridType: 'string',
      ignoreRowCopy: true,
      isParentWithDivider: false,
      readOnly: true,
      rowSpan: 1,
      columnSpan: 2,
      value: SHEET_TITLES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADERS[0].value,
      isTitleOrHeader: true,
    },
    ...(gpcComparison.length > 0
      ? comparisonCompanies({
        gpcComparison: gpcComparison as CalibrationComparison[],
        isDisabled,
      })
      : []),
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_COMPANY,
      displayBold: true,
      className: 'bolder-row division',
      format: oneDecimalPercentFormatValidateFloatTrue,
      gridType: 'percentage',
      ignoreRowCopy: true,
      readOnly: true,
      value: company?.name,
    },
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_RANK_ALIAS,
      hidden: false,
      gridType: 'percentage',
      format: oneDecimalPercentFormatValidateFloatTrue,
      value: PERCENTILE_RANKING_TITLE,
      forceComponent: true,
      readOnly: true,
    },
  ];
};

export default rowConfigCalibrationPerformance;
